import theme from '@styles/theme';
export default {
  productCard: {
    width: '100%',
    height: 'auto',
    '&:hover .hoverImage': {
      opacity: 1
    },
    '&:hover .bottom_labels span': {
      transform: 'translateY(-10px)'
    }
  },
  visualArea: (transparent = false) => ({
    bg: transparent ? 'transparent' : theme.rawColors.lightGreyBgProduct,
    position: 'relative'
  })
};